// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Orders',
    path: '/dashboard/orders',
    icon: getIcon('eva:shopping-bag-fill'),
    showTo: 'admin', // use all if want to show to all
  },
  {
    title: 'Users',
    path: '/dashboard/users',
    icon: getIcon('clarity:users-solid'),
    showTo: 'admin', // use all if want to show to all
  },
  {
    title: 'Supplier Report',
    path: '/dashboard/supplier-report',
    icon: getIcon('tabler:report-analytics'),
    showTo: 'supplier',
  },
  {
    title: 'Customer Validation Report',
    path: '/dashboard/customer-validation-report',
    icon: getIcon('streamline:user-check-validate'),
    showTo: 'supplier',
  },
  {
    title: 'Stock Transfers',
    path: '/dashboard/stock-transfers',
    icon: getIcon('solar:square-transfer-horizontal-broken'),
    showTo: 'supplier',
  },
  {
    title: 'Warehouse List',
    path: '/dashboard/warehouse-list',
    icon: getIcon('lucide:warehouse'),
    showTo: 'admin',
  },
  {
    title: 'Supplier List',
    path: '/dashboard/supplier-list',
    icon: getIcon('ph:user-list-bold'),
    showTo: 'admin',
  },
  {
    title: 'Product List',
    path: '/dashboard/product-list',
    icon: getIcon('cil:list-rich'),
    showTo: 'admin',
  },
  {
    title: 'Stock Report',
    path: '/dashboard/stock-report',
    icon: getIcon('ant-design:stock-outlined'),
    showTo: 'admin',
  },
  {
    title: 'Email Schedular',
    path: '/dashboard/email-schedular',
    icon: getIcon('mdi:message-text-clock-outline'),
    showTo: 'admin',
  },
  {
    title: 'Export',
    icon: getIcon('solar:export-bold'),
    children: [
      {
        title: 'Manage Exporters',
        path: '/dashboard/exporters',
      },

      {
        title: 'Manage Exports',
        path: '/dashboard/exports',
      },
    ],
    showTo: 'admin',
  },
  {
    title: 'Import',
    icon: getIcon('solar:import-bold'),
    children: [
      {
        title: 'Manage Import Locations',
        path: '/dashboard/import-locations',
      },
      {
        title: 'Manage Imports',
        path: '/dashboard/imports',
      },
    ],
    showTo: 'admin',
  },
  {
    title: 'Export',
    // path: '/dashboard/email-schedular',
    icon: getIcon('solar:export-bold'),
    children: [
      {
        title: 'Manage Exports',
        path: '/dashboard/supplier-exports',
      },
    ],
    showTo: 'supplier',
  },
  {
    title: 'Import',
    // path: '/dashboard/email-schedular',
    icon: getIcon('solar:import-bold'),
    children: [
      {
        title: 'Manage Imports',
        path: '/dashboard/supplier-imports',
      },
    ],
    showTo: 'supplier',
  },
];

export default navConfig;
